import type { KnowledgeArticleTranslations } from './articles.types';

export const KNOWLEDGE_BASE_ARTICLES_NE: KnowledgeArticleTranslations = {
  pickup: {
    title: 'सङ्कलन आदेश',
    summary: "पिकअप अर्डर सिर्जना, ट्र्याक र व्यवस्थापन गर्नुहोस्।",
    content:
      'सङ्कलन आदेशहरू तपाईंका साइटहरूबाट फोहोर सङ्कलनको समयतालिका बनाउन प्रयोग हुन्छन्। साइडबारबाट «सङ्कलन आदेश» खोल्नुहोस् ताकि नयाँ आदेश सिर्जना गर्न, सूची हेर्न वा स्थिति ट्र्याक गर्न सकियोस्।\n\nचरणबद्ध निर्देशनका लागि तल एउटा मार्गदर्शन छान्नुहोस्।',
  },
  'view-pickup-orders-list': {
    title: "पिकअप अर्डर सूची हेर्नुहोस्",
    summary: "अर्डर तालिका खोल्नुहोस्, खोज्नुहोस् र पिकअप अनुरोध ब्राउज गर्नुहोस्।",
    content:
      "1. साइडबारमा «पिकअप अर्डर» खोल्नुहोस्।\n\n2. मुख्य तालिकाले तपाईंको संस्थाका पिकअप अर्डर ID, सङ्कलन स्थल, स्थिति र मितिसहित देखाउँछ।\n\n3. ID वा सङ्कलन स्थलबाट अर्डर खोज्न तालिका माथिको खोज बाकस प्रयोग गर्नुहोस्।\n\n4. थप पङ्क्ति हेर्न स्क्रोल गर्नुहोस् र तल पेजिनेसन प्रयोग गर्नुहोस्।\n\nसुझाव: स्थिति चिप्स र मिति फिल्टरले नतिजा साँघुरा पार्छन् — सम्बन्धित गाइड हेर्नुहोस्।",
  },
  'create-pickup-order-outlet': {
    title: 'नयाँ सङ्कलन आदेश सिर्जना गर्नुहोस्',
    summary: "फोहोर पिकअप तालिका मिलाउन चरणबद्ध गाइड।",
    content:
      '1. साइडबारबाट «सङ्कलन आदेश» खोल्नुहोस् अनि «सङ्कलन आदेश सिर्जना गर्नुहोस्» (वा सङ्कलन आदेश पृष्ठमा + बटन थिच्नुहोस्)।\n\n2. आदेश विवरण:\n   • सामग्री प्रकार (अनिवार्य) — फोहोर श्रेणी र मापन एकाइ स्वतः भरिन्छ।\n\n3. स्थान र कन्टेनर:\n   • सङ्कलन स्थल (अनिवार्य)\n   • छानिएको स्थलको कन्टेनर\n   • भराइ स्तर — पूर्ण, तीन चौथाई, आधा, वा एक चौथाई भरिएको\n\n4. «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्। आदेश सूचीमा «प्रतीक्षामा» स्थितिमा देखिन्छ।',
  },
  material: {
    title: 'सामग्री',
    summary: "पिकअप अर्डरका लागि सामग्री प्रकार थप्नुहोस्, सम्पादन र व्यवस्थापन गर्नुहोस्।",
    content:
      'सामग्री प्रकार थप्न र सम्पादन गर्ने तरिका जान्न तलबाट एउटा मार्गदर्शन छान्नुहोस्।',
  },
  'add-material-type': {
    title: 'सामग्री प्रकार थप्नुहोस्',
    summary: "पिकअप अर्डरका लागि फोहोर सामग्री प्रकार दर्ता गर्नुहोस्।",
    content:
      '1. साइडबारबाट «पुनःप्रयोग» खोल्नुहोस् अनि «सामग्री प्रकार»।\n\n2. «सामग्री थप्नुहोस्» (माथि दायाँ) मा क्लिक गर्नुहोस्।\n\n3. सामग्रीको नाम, श्रेणी र मापन एकाइ प्रविष्ट गर्नुहोस् (जस्तै: किलो, टन, झोला)।\n\n4. «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्। सङ्कलन आदेश सिर्जना गर्दा सामग्री उपलब्ध हुन्छ।',
  },
  container: {
    title: 'कन्टेनर',
    summary: "फोहोर कन्टेनर थप्नुहोस्, व्यवस्थापन र ट्र्याक गर्नुहोस्।",
    content:
      'कन्टेनर व्यवस्थापन गर्ने तरिका जान्न तलबाट एउटा मार्गदर्शन छान्नुहोस्।',
  },
  'add-container': {
    title: 'नयाँ कन्टेनर थप्नुहोस्',
    summary: "सङ्कलन स्थलमा फोहोर कन्टेनर दर्ता गर्नुहोस्।",
    content:
      '1. साइडबारबाट «कन्टेनर» खोल्नुहोस् अनि «कन्टेनर सूची»।\n\n2. «कन्टेनर थप्नुहोस्» (माथि दायाँ) मा क्लिक गर्नुहोस्।\n\n3. कन्टेनर विवरण भर्नुहोस्: नाम, सामग्री प्रकार, सङ्कलन स्थल, स्थिति र अन्य आवश्यक क्षेत्रहरू।\n\n4. «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्। कन्टेनर सूचीमा देखिन्छ र सङ्कलन आदेश सिर्जना गर्दा छान्न सकिन्छ।',
  },
  'collection-site': {
    title: 'सङ्कलन स्थल',
    summary: "फोहोर सङ्कलन स्थल थप्नुहोस्, सम्पादन र व्यवस्थापन गर्नुहोस्।",
    content:
      'सङ्कलन स्थल व्यवस्थापन गर्ने तरिका जान्न तलबाट एउटा मार्गदर्शन छान्नुहोस्।',
  },
  'add-collection-site': {
    title: 'नयाँ सङ्कलन स्थल थप्नुहोस्',
    summary: "फोहोर सङ्कलन हुने स्थान सिर्जना गर्नुहोस्।",
    content:
      '1. साइडबारबाट «कन्टेनर» खोल्नुहोस् अनि «सङ्कलन स्थल»।\n\n2. «स्थल थप्नुहोस्» (माथि दायाँ) मा क्लिक गर्नुहोस्।\n\n3. स्थलको नाम, ठेगाना र आवश्यक विवरण प्रविष्ट गर्नुहोस्।\n\n4. «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्। अब तपाईं कन्टेनरहरू यस स्थलसँग जोड्न र सङ्कलन आदेश फारममा छान्न सक्नुहुन्छ।',
  },

  truck: {
    title: 'ट्रक',
    summary: "सवारी थप्नुहोस्, फ्लीट स्थिति बुझ्नुहोस् र ट्रक व्यवस्थापन गर्नुहोस्।",
    content:
      'सवारी बेडा व्यवस्थापन गर्ने तरिका जान्न तलबाट एउटा मार्गदर्शन छान्नुहोस्।',
  },
  'add-vehicle': {
    title: 'सवारी थप्नुहोस्',
    summary: "पूर्ण विवरणसहित नयाँ ट्रक वा फ्लीट सवारी दर्ता गर्नुहोस्।",
    content:
      '1. साइडबारबाट «ट्रक» खोल्नुहोस् ताकि «बेडा व्यवस्थापन» मा पुग्न सकियोस्।\n\n2. «सवारी थप्नुहोस्» (माथि दायाँ) मा क्लिक गर्नुहोस्।\n\n3. फारम भर्नुहोस्:\n   • नम्बर प्लेट (अरबी र अङ्ग्रेजी)\n   • सवारीको नाम (अनिवार्य)\n   • क्षमता र क्षमता एकाइ\n   • सवारी प्रकार, मोडेल, VIN, खाली तौल र इन्धन खपत\n   • स्थिति — सवारी तोक्न तयार भए «उपलब्ध» छान्नुहोस्\n\n4. «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्। सवारी बेडा तालिकामा देखिन्छ।',
  },
  driver: {
    title: 'चालक',
    summary: "चालक दर्ता गर्नुहोस्, प्रोफाइल हेर्नुहोस् र ट्रक असाइनमेन्ट व्यवस्थापन गर्नुहोस्।",
    content:
      'चालक व्यवस्थापन गर्ने तरिका जान्न तलबाट एउटा मार्गदर्शन छान्नुहोस्।',
  },
  'add-driver': {
    title: 'चालक थप्नुहोस्',
    summary: "लाइसेन्स र व्यक्तिगत विवरणसहित चालक खाता सिर्जना गर्नुहोस्।",
    content:
      '1. साइडबारबाट «चालक» खोल्नुहोस्।\n\n2. «चालक थप्नुहोस्» (माथि दायाँ) मा क्लिक गर्नुहोस्।\n\n3. खाता खण्ड: इमेल, पासवर्ड र यसको पुष्टि।\n\n4. व्यक्तिगत खण्ड: नाम, फोन नम्बर, लिङ्ग, राष्ट्रियता र अन्य।\n\n5. चालक र सवारी खण्ड: ड्राइभिङ लाइसेन्स नम्बर, म्याद सकिने मिति र सवारी दर्ता नम्बर।\n\n6. «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्। चालक तालिकामा देखिन्छ।',
  },
  'understanding-notifications': {
    title: 'सूचनाहरू',
    summary: "प्लेटफर्म अलर्ट सक्षम गर्ने, पढ्ने र व्यवस्थापन गर्ने तरिका।",
    content:
      'ब्राउजर सूचनाहरू सक्षम गर्नुहोस्:\nअनुमति अनुरोध आउँदा «अनुमति दिनुहोस्» मा क्लिक गर्नुहोस् ताकि एप बाहिर आदेश र प्लेटफर्म अद्यावधिक पाउन सकियोस्।\n\nसूचनाहरू हेर्नुहोस्:\n1. माथिल्लो पट्टीमा घण्टी आइकनमा क्लिक गर्नुहोस्।\n2. प्यानलमा नपढिएका सूचनाहरू शीर्षक, सन्देश र समयसहित देखिन्छन्।\n3. कुनै सूचनामा क्लिक गरी पढिएको चिन्ह लगाउनुहोस्।\n4. «सबै पढिएको चिन्ह लगाउनुहोस्» प्रयोग गरी सबै नपढिएका सूचनाहरू एकै पटक हटाउनुहोस्।\n\nमहत्त्वपूर्ण:\n• घण्टीमा देखिने संख्याले नपढिएका सूचनाहरूको गणना देखाउँछ।',
  },
  'pickup-order-statuses': {
    title: 'सङ्कलन आदेशको स्थिति',
    summary: "सञ्चालन हुँदै जाँदा प्रत्येक अर्डर स्थितिको अर्थ।",
    content:
      '«सङ्कलन आदेश» सूचीबाट हालको स्थिति हेर्न सकिन्छ। आदेशको प्रगतिसँग स्थिति स्वतः अद्यावधिक हुन्छ।\n\n• प्रतीक्षामा — आदेश सिर्जना भयो र प्रशोधन वा तोकाइको प्रतीक्षामा छ।\n• ढुवानीमा — फोहोर सङ्कलन वा ढुवानी जारी छ।\n• पूरा — आदेश सफलतापूर्वक पूरा भयो।\n• रद्द — आदेश रद्द गरियो र पूरा हुने छैन।',
  },
  'filter-pickup-orders-by-date': {
    title: 'मिति अनुसार आदेश फिल्टर गर्नुहोस्',
    summary: "निर्दिष्ट मिति दायराभित्र अर्डर खोज्नुहोस्।",
    content:
      '1. साइडबारबाट «सङ्कलन आदेश» खोल्नुहोस्।\n\n2. «मिति अनुसार फिल्टर» खण्डमा जानुहोस्।\n\n3. सुरु र अन्त्य मिति तोक्नुहोस्।\n\n4. सूची फिल्टर गर्न «मितिहरू लागू गर्नुहोस्» मा क्लिक गर्नुहोस्।\n\n5. फिल्टर हटाउन र पूर्वनिर्धारित दृश्यमा फर्कन «मितिहरू खाली गर्नुहोस्» मा क्लिक गर्नुहोस्।',
  },
  'container-fill-level': {
    title: 'कन्टेनर भराइ स्तर',
    summary: "कन्टेनरका लागि सहि भर्ने स्तर छान्ने तरिका।",
    content:
      '«सङ्कलन आदेश सिर्जना गर्नुहोस्» फारममा कन्टेनर छान्दा भराइ स्तर अनिवार्य हुन्छ।\n\nउपलब्ध विकल्पहरू:\n• पूर्ण — कन्टेनर पूर्ण रूपमा भरिएको\n• तीन चौथाई भरिएको — लगभग ७५% भरिएको\n• आधा भरिएको — लगभग ५०% भरिएको\n• एक चौथाई भरिएको — लगभग २५% भरिएको\n\nवास्तविक अवस्थाको नजिकको स्तर छान्नुहोस् ताकि सञ्चालन र चालकहरू राम्रो योजना बनाउन सकून्।',
  },
  'container-statuses': {
    title: 'कन्टेनरको स्थिति',
    summary: "प्रत्येक कन्टेनर स्थितिको अर्थ र कहिले प्रयोग गर्ने।",
    content:
      '«कन्टेनर सूची» बाट कन्टेनर थप्दा वा सम्पादन गर्दा स्थिति तोक्न वा समीक्षा गर्न सकिन्छ।\n\n• सङ्कलनका लागि तयार — कन्टेनर तयार छ र फोहोर सङ्कलन गर्न सकिन्छ।\n• सङ्कलनको प्रतीक्षामा — सङ्कलन तालिकाबद्ध वा कार्यको प्रतीक्षामा।\n• खाली — सङ्कलन गर्न फोहोर छैन।\n• मर्मतमा — कन्टेनर अस्थायी रूपमा सेवाबाट बाहिर।\n• तयारीमा — कन्टेनर सेटअप भइरहेको।\n• निष्क्रिय — कन्टेनर हाल प्रयोगमा छैन।',
  },
  'print-container-qr': {
    title: 'कन्टेनर QR कोड प्रिन्ट गर्नुहोस्',
    summary: "फिल्ड प्रयोगका लागि QR लेबल बनाउनुहोस् र प्रिन्ट गर्नुहोस्।",
    content:
      '1. «कन्टेनर» ← «कन्टेनर सूची» खोल्नुहोस्।\n\n2. तालिकामा कन्टेनर खोज्नुहोस्।\n\n3. पङ्क्तिमा QR आइकनमा क्लिक गर्नुहोस्।\n\n4. प्रिन्ट संवादबाट लेबल प्रिन्ट गर्नुहोस्।\n\nलेबल स्थलमा कन्टेनरमा टाँस्नुहोस् ताकि पहिचान र क्षेत्र स्क्यानिङ सजिलो होस्।',
  },
  'edit-material-type': {
    title: 'सामग्री प्रकार सम्पादन वा मेटाउनुहोस्',
    summary: "रिसाइक्लिंग सेटिङबाट सामग्री प्रकार अपडेट वा हटाउनुहोस्।",
    content:
      '1. «पुनःप्रयोग» ← «सामग्री प्रकार» खोल्नुहोस्।\n\n2. सम्पादनका लागि: सम्पादन आइकनमा क्लिक गर्नुहोस्, विवरण परिवर्तन गर्नुहोस्, अनि «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्।\n\n3. मेटाउनका लागि: मेटाउने आइकनमा क्लिक गर्नुहोस्, अनि कार्य पुष्टि गर्नुहोस्।\n\nचेतावनी: सक्रिय सङ्कलन आदेशसँग जोडिएको सामग्री प्रकार मेटाउनुहोस् होइन। पहिले ती आदेशहरू पूरा वा अद्यावधिक गर्नुहोस्।',
  },
  'edit-or-delete-container': {
    title: 'कन्टेनर सम्पादन वा मेटाउनुहोस्',
    summary: "सूचीबाट कन्टेनर अपडेट वा हटाउनुहोस्।",
    content:
      '1. «कन्टेनर» ← «कन्टेनर सूची» खोल्नुहोस्।\n\n2. सम्पादनका लागि: सम्पादन आइकनमा क्लिक गर्नुहोस्, विवरण परिवर्तन गर्नुहोस्, अनि «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्।\n\n3. मेटाउनका लागि: मेटाउने आइकनमा क्लिक गर्नुहोस्, अनि कार्य पुष्टि गर्नुहोस्।\n\nचेतावनी: कन्टेनर सङ्कलन आदेशसँग जोडिएको हुन सक्छ। मेटाउनु अघि पुष्टि गर्नुहोस्।',
  },
  'edit-or-delete-collection-site': {
    title: 'सङ्कलन स्थल सम्पादन वा मेटाउनुहोस्',
    summary: "सङ्कलन स्थल अपडेट वा हटाउनुहोस्।",
    content:
      '1. «कन्टेनर» ← «सङ्कलन स्थल» खोल्नुहोस्।\n\n2. स्थल कार्डमा «सम्पादन» वा «मेटाउनुहोस्» मा क्लिक गर्नुहोस्।\n\n3. अनुरोध गरिएमा मेटाउने पुष्टि गर्नुहोस्।\n\nचेतावनी: स्थल कन्टेनर र सङ्कलन आदेशसँग जोडिएको हुन सक्छ। मेटाउनु अघि सम्बन्ध समीक्षा गर्नुहोस्।',
  },
  'truck-statuses': {
    title: 'सवारीको स्थिति',
    summary: "प्रत्येक फ्लीट सवारी स्थितिको अर्थ र कहिले प्रयोग गर्ने।",
    content:
      'प्रत्येक सवारीको स्थिति «बेडा व्यवस्थापन» तालिकामा देखिन्छ। थप्दा वा सम्पादन गर्दा अद्यावधिक गर्न सकिन्छ।\n\n• उपलब्ध — सवारी चालक वा यात्राका लागि तोक्न तयार।\n• अनुपलब्ध — सवारी हाल प्रयोग गर्न सकिँदैन।\n• ढुवानीमा — सवारी बाटोमा।\n• लोडिङ / अनलोडिङ — सवारी लोडिङ वा अनलोडिङ स्थलमा।\n• मर्मतमा — सवारी मर्मत वा सेवामा।\n\nसुझाव: अस्थायी रोकमा «अनुपलब्ध» वा «मर्मतमा» राख्नुहोस्, मेटाउनुहोस् होइन।',
  },
  'view-driver-details': {
    title: 'चालक विवरण हेर्नुहोस्',
    summary: "चालक प्रोफाइल, लाइसेन्स जानकारी र तोकिएको ट्रक खोल्नुहोस्।",
    content:
      '1. साइडबारबाट «चालक» खोल्नुहोस्।\n\n2. तालिकामा चालक खोज्नुहोस्।\n\n3. विवरण खोल्न हेर्नुहोस् (आँखा) आइकनमा क्लिक गर्नुहोस्।\n\n4. संवादमा देखाइन्छ: खाता जानकारी, व्यक्तिगत विवरण, लाइसेन्स जानकारी र तोकिएको ट्रक भए।\n\n5. सम्पादनका लागि: संवादमा «सम्पादन» मा क्लिक गर्नुहोस्, वा पङ्क्ति कार्य मेनु प्रयोग गर्नुहोस्।\n\nट्रक «तोकिएको छैन» देखाए कार्य मेनुबाट «ट्रकमा तोक्नुहोस्» छान्नुहोस्।',
  },
  'edit-or-delete-vehicle': {
    title: 'सवारी सम्पादन वा मेटाउनुहोस्',
    summary: "सवारी विवरण अपडेट गर्नुहोस् वा फ्लीटबाट ट्रक हटाउनुहोस्।",
    content:
      'सवारी सम्पादन:\n1. «ट्रक» ← «बेडा व्यवस्थापन» खोल्नुहोस्।\n2. पङ्क्तिमा सम्पादन आइकनमा क्लिक गर्नुहोस्, वा विवरण खोलेर «सम्पादन» छान्नुहोस्।\n3. क्षेत्रहरू परिवर्तन गरी «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्।\n\nसवारी मेटाउनुहोस्:\n1. पङ्क्तिमा मेटाउने आइकनमा क्लिक गर्नुहोस्, वा विवरणबाट मेटाउनुहोस्।\n2. मेटाउने पुष्टि गर्नुहोस्।\n\nचेतावनी: सवारी चालकलाई तोकिएको वा सक्रिय यात्रासँग जोडिएको भए मेटाउँदा सञ्चालनमा असर पर्न सक्छ।',
  },
  'edit-or-delete-driver': {
    title: 'चालक सम्पादन र ट्रक तोकाइ',
    summary: "चालक जानकारी अपडेट गर्नुहोस् र ट्रक असाइनमेन्ट व्यवस्थापन गर्नुहोस्।",
    content:
      'चालक विवरण सम्पादन:\n1. «चालक» खोल्नुहोस्।\n2. पङ्क्ति कार्य मेनुबाट «चालक सम्पादन» छान्नुहोस्।\n3. विवरण परिवर्तन गरी «सुरक्षित गर्नुहोस्» मा क्लिक गर्नुहोस्।\n\nविकल्प: हेर्नुहोस् आइकनमा क्लिक गरी विवरणबाट «सम्पादन» छान्नुहोस्।\n\nट्रक तोक्नुहोस्:\n1. कार्य मेनुबाट «ट्रकमा तोक्नुहोस्» छान्नुहोस्।\n2. उपलब्ध ट्रक (जसमा चालक तोकिएको छैन) छानेर पुष्टि गर्नुहोस्।\n\nतोकाइ रद्द:\n1. कार्य मेनुबाट «ट्रकबाट तोकाइ रद्द» छान्नुहोस् (तोकाइ भएमा मात्र देखिन्छ)।\n2. कार्य पुष्टि गर्नुहोस्।',
  },
};
